import moment from 'moment';

/**
 * Convert date from YYYY-MM-DD format (HTML date input) to MMDDYYYY format
 * @param dateValue - Date string in YYYY-MM-DD format or Date object
 * @returns Date string in MMDDYYYY format (e.g., "01052025" for January 5, 2025)
 */
export const convertToMMDDYYYY = (dateValue: string | Date | null | undefined): string => {
  if (!dateValue) {
    return '';
  }

  try {
    const date = moment(dateValue);
    if (!date.isValid()) {
      return '';
    }
    return date.format('MMDDYYYY');
  } catch (error) {
    console.warn('Failed to convert date to MMDDYYYY:', dateValue, error);
    return '';
  }
};

/**
 * Convert date from MMDDYYYY format to YYYY-MM-DD format (for HTML date input)
 * @param dateValue - Date string in MMDDYYYY format (e.g., "01052025")
 * @returns Date string in YYYY-MM-DD format (e.g., "2025-01-05")
 */
export const convertFromMMDDYYYY = (dateValue: string | null | undefined): string => {
  if (!dateValue || dateValue.trim() === '') {
    return '';
  }

  try {
    // Try parsing MMDDYYYY format using UTC to avoid timezone issues
    const parsed = moment.utc(dateValue, 'MMDDYYYY', true);
    if (parsed.isValid()) {
      return parsed.format('YYYY-MM-DD');
    }

    // Fallback: try parsing other common formats using UTC
    const fallbackFormats = ['YYYY-MM-DD', 'MM/DD/YYYY', 'YYYY/MM/DD', 'MM-DD-YYYY'];
    for (const format of fallbackFormats) {
      const parsedFallback = moment.utc(dateValue, format, true);
      if (parsedFallback.isValid()) {
        return parsedFallback.format('YYYY-MM-DD');
      }
    }

    // Last resort: try moment's default parsing with UTC
    const defaultParsed = moment.utc(dateValue);
    if (defaultParsed.isValid()) {
      return defaultParsed.format('YYYY-MM-DD');
    }

    return '';
  } catch (error) {
    console.warn('Failed to convert date from MMDDYYYY:', dateValue, error);
    return '';
  }
};

